import { render, staticRenderFns } from "./FeaturedMemberViewer.vue?vue&type=template&id=0d8ef67b&"
import script from "./FeaturedMemberViewer.vue?vue&type=script&lang=js&"
export * from "./FeaturedMemberViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports